import convertParamsToStr from '@/core/responsive/image/helpers/convert-params-to-string';
import { IExtendedImageOptions } from '@/core/responsive/image/image.types';
import responsiveImageService from '@/core/responsive/image/responsive-image.service';

function generateCdnUrlWithParams(src: string, options: Partial<IExtendedImageOptions>, isProductImage: boolean = false): string {
    const cdnUrls = responsiveImageService.getBaseUrls();
    const cdnUrl = isProductImage ? cdnUrls.cdnProductImages : cdnUrls.cdnAssetImages;

    const version = options.cacheBust ?? 1;
    delete options.cacheBust;

    const paramsToStr = convertParamsToStr(options);

    return `${cdnUrl}/cdn-cgi/image/${paramsToStr}${src}?v=${version}`;
}

export default generateCdnUrlWithParams;
